import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "../../../utils/setPageMeta";

const CSS_TEXT = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500;700&display=swap');

.bk-page *,.bk-page *::before,.bk-page *::after{box-sizing:border-box;margin:0;padding:0;}
.bk-page{
  --purple:#5C159F;--purple-deep:#2B0A52;--gold:#FFBB00;--lavender:#F6F1FC;
  --ink:#1A1330;--ink-soft:#6B6480;--line:#E4D9F5;--white:#FFFFFF;
  --green:#1E8E5A;--amber:#B5790B;
  min-height:100vh;background:var(--lavender);font-family:'Inter',sans-serif;color:var(--ink);
}

.bk-topbar{background:var(--white);border-bottom:1px solid var(--line);padding:18px 48px;display:flex;align-items:center;justify-content:space-between;}
.bk-brand{font-family:'Sora',sans-serif;font-weight:800;font-size:20px;color:var(--purple);text-decoration:none;}
.bk-brand span{color:var(--gold);}

.bk-layout{max-width:1180px;margin:0 auto;padding:40px 48px 80px;display:grid;grid-template-columns:1fr 380px;gap:48px;}

.bk-steps{display:flex;gap:28px;margin-bottom:32px;}
.bk-step{display:flex;align-items:center;gap:10px;font-family:'Sora',sans-serif;font-size:13px;font-weight:600;color:var(--ink-soft);}
.bk-step.active{color:var(--purple);}
.bk-step-num{width:22px;height:22px;border-radius:50%;background:var(--line);color:var(--ink-soft);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;}
.bk-step.active .bk-step-num{background:var(--purple);color:var(--white);}
.bk-step.done .bk-step-num{background:var(--green);color:var(--white);}
.bk-step-rule{flex:1;height:1px;background:var(--line);align-self:center;}

h1.bk-title{font-family:'Sora',sans-serif;font-size:27px;font-weight:800;margin:0 0 6px;letter-spacing:-0.01em;text-shadow:none;}
.bk-sub{color:var(--ink-soft);font-size:14.5px;margin:0 0 30px;}

.bk-section{background:var(--white);border:1px solid var(--line);border-radius:16px;padding:26px 28px 28px;margin-bottom:22px;}
.bk-section-label{font-family:'JetBrains Mono',monospace;font-size:11px;letter-spacing:0.08em;color:var(--purple);text-transform:uppercase;margin:0 0 14px;font-weight:700;}

.bk-mentor-row{display:flex;gap:14px;align-items:center;border:1.5px solid var(--purple);background:#FBF8FF;border-radius:12px;padding:14px 16px;}
.bk-avatar{width:44px;height:44px;border-radius:10px;background:linear-gradient(135deg,var(--purple),#8A3FD1);color:var(--white);display:flex;align-items:center;justify-content:center;font-family:'Sora',sans-serif;font-weight:700;font-size:15px;flex-shrink:0;}
.bk-mentor-name{font-family:'Sora',sans-serif;font-weight:700;font-size:14.5px;margin:0;}
.bk-mentor-college{font-size:12.5px;color:var(--ink-soft);margin:2px 0 0;}
.bk-change-link{margin-left:auto;font-size:12.5px;font-weight:600;color:var(--purple);cursor:pointer;background:none;border:none;font-family:'Inter',sans-serif;text-decoration:none;}

.bk-textarea{width:100%;border:1.5px solid var(--line);border-radius:11px;padding:13px 14px;font-family:'Inter',sans-serif;font-size:13.5px;color:var(--ink);resize:vertical;min-height:84px;outline:none;}
.bk-textarea:focus{border-color:var(--purple);}
.bk-char-count{font-size:11.5px;color:var(--ink-soft);text-align:right;margin-top:6px;}

.bk-date-row{display:flex;gap:10px;margin-bottom:18px;overflow-x:auto;padding-bottom:4px;}
.bk-date-pill{flex-shrink:0;min-width:64px;border:1.5px solid var(--line);border-radius:10px;padding:10px 6px;text-align:center;cursor:pointer;background:var(--white);}
.bk-date-pill .bk-dow{font-size:10.5px;color:var(--ink-soft);font-weight:600;text-transform:uppercase;}
.bk-date-pill .bk-dom{font-family:'Sora',sans-serif;font-weight:700;font-size:17px;margin-top:2px;color:var(--ink);}
.bk-date-pill.selected{border-color:var(--purple);background:var(--purple);}
.bk-date-pill.selected .bk-dow,.bk-date-pill.selected .bk-dom{color:var(--white);}

.bk-slot-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;}
.bk-slot{border:1.5px solid var(--line);border-radius:9px;padding:11px 0;text-align:center;font-size:13px;font-weight:600;cursor:pointer;background:var(--white);color:var(--ink);font-family:'Inter',sans-serif;}
.bk-slot:hover{border-color:#C9AEEC;}
.bk-slot.selected{background:var(--gold);border-color:var(--gold);color:var(--ink);}

.bk-hold-banner{display:flex;align-items:center;gap:8px;background:#FFF8E6;border:1px solid #F5DD9C;border-radius:10px;padding:10px 14px;margin-top:16px;font-size:12.5px;color:var(--amber);font-weight:600;}
.bk-hold-dot{width:7px;height:7px;border-radius:50%;background:var(--amber);flex-shrink:0;}

/* TICKET */
.bk-ticket-wrap{position:sticky;top:24px;height:fit-content;}
.bk-ticket{background:var(--purple-deep);border-radius:18px;color:var(--white);overflow:hidden;box-shadow:0 18px 40px -12px rgba(43,10,82,0.45);}
.bk-ticket-top{padding:22px 24px 16px;}
.bk-ticket-eyebrow{font-family:'JetBrains Mono',monospace;font-size:10.5px;letter-spacing:.1em;color:var(--gold);text-transform:uppercase;font-weight:700;margin:0 0 8px;}
.bk-ticket-title{font-family:'Sora',sans-serif;font-weight:800;font-size:18px;margin:0 0 4px;}
.bk-ticket-timer{font-family:'JetBrains Mono',monospace;font-size:12px;color:var(--gold);margin-top:8px;display:flex;align-items:center;gap:6px;}
.bk-ticket-row{display:flex;justify-content:space-between;align-items:flex-start;padding:12px 24px;border-top:1px dashed rgba(255,255,255,0.18);font-size:13px;}
.bk-ticket-row .bk-label{color:rgba(255,255,255,0.55);font-size:11px;text-transform:uppercase;letter-spacing:.04em;font-family:'JetBrains Mono',monospace;}
.bk-ticket-row .bk-value{font-weight:600;text-align:right;max-width:200px;}
.bk-ticket-row .bk-value.muted{color:rgba(255,255,255,0.5);font-weight:500;}

.bk-perforation{position:relative;height:0;border-top:1px dashed rgba(255,255,255,0.25);margin:6px 0;}
.bk-perforation::before,.bk-perforation::after{content:"";position:absolute;top:-9px;width:18px;height:18px;border-radius:50%;background:var(--lavender);}
.bk-perforation::before{left:-9px;}
.bk-perforation::after{right:-9px;}

.bk-ticket-bottom{padding:18px 24px 22px;}
.bk-plan-label{font-size:12px;color:rgba(255,255,255,0.6);margin:0 0 10px;font-weight:600;}
.bk-plan-chips{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
.bk-plan-chip{background:rgba(255,255,255,0.06);border:1.5px solid rgba(255,255,255,0.16);border-radius:10px;padding:10px 12px;cursor:pointer;text-align:left;display:flex;flex-direction:column;gap:3px;font-family:'Inter',sans-serif;}
.bk-plan-chip .bk-pc-name{font-size:11.5px;color:rgba(255,255,255,0.65);font-weight:600;}
.bk-plan-chip .bk-pc-price{font-family:'Sora',sans-serif;font-weight:700;font-size:14.5px;color:var(--white);}
.bk-plan-chip.selected{background:rgba(255,187,0,0.14);border-color:var(--gold);}
.bk-plan-chip.selected .bk-pc-price{color:var(--gold);}
.bk-plan-benefits{list-style:none;margin:10px 0 0;padding:0;display:flex;flex-direction:column;gap:5px;}
.bk-plan-benefits li{font-size:12px;color:rgba(255,255,255,0.75);padding-left:16px;position:relative;}
.bk-plan-benefits li::before{content:"\\2713";position:absolute;left:0;color:var(--gold);font-weight:700;font-size:11px;}
.bk-compare-link{display:block;text-align:center;font-size:11.5px;color:rgba(255,255,255,0.6);text-decoration:underline;margin-top:12px;}
.bk-price-row{display:flex;align-items:baseline;gap:10px;margin-top:14px;}
.bk-price-old{font-size:13px;color:rgba(255,255,255,0.45);text-decoration:line-through;}
.bk-price-new{font-family:'Sora',sans-serif;font-weight:800;font-size:24px;color:var(--gold);}
.bk-price-caption{font-size:11px;color:rgba(255,255,255,0.55);margin-top:4px;}

.bk-cta-btn{display:block;width:100%;background:var(--gold);color:var(--ink);border:none;padding:15px 0;font-family:'Sora',sans-serif;font-weight:700;font-size:14.5px;border-radius:11px;cursor:pointer;margin-top:6px;}
.bk-cta-btn:hover{filter:brightness(0.96);}
.bk-cta-btn:disabled{opacity:0.6;cursor:not-allowed;}
.bk-cta-sub{text-align:center;font-size:11px;color:rgba(255,255,255,0.5);margin-top:10px;}

.bk-trust-strip{margin-top:16px;background:var(--white);border:1px solid var(--line);border-radius:14px;padding:14px 18px;}
.bk-trust-row{display:flex;align-items:center;gap:10px;font-size:12px;color:var(--ink-soft);padding:5px 0;}
.bk-trust-row b{color:var(--ink);}
.bk-trust-icon{color:var(--green);font-weight:700;}

/* ERROR / SUCCESS */
.bk-msg{padding:14px 18px;border-radius:12px;margin-bottom:20px;font-size:14px;font-weight:600;text-align:center;}
.bk-msg-err{background:#FFF8E6;color:#B5790B;border:1px solid #F5DD9C;}
.bk-msg-ok{background:rgba(30,142,90,0.18);color:#8FE0B8;border:1px solid rgba(30,142,90,0.4);}

@media(max-width:880px){
  .bk-layout{grid-template-columns:1fr;padding:24px 20px 60px;}
  .bk-ticket-wrap{position:relative;}
  .bk-slot-grid{grid-template-columns:repeat(2,1fr);}
  .bk-topbar{padding:14px 20px;}
}
`;

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const SLOTS = [
  { label: "10:00 AM", value: "10AM:11AM" },
  { label: "11:30 AM", value: "11:30AM:12:30PM" },
  { label: "1:00 PM", value: "1PM:2PM" },
  { label: "2:30 PM", value: "2:30PM:3:30PM" },
  { label: "4:00 PM", value: "4PM:5PM" },
  { label: "5:30 PM", value: "5:30PM:6:30PM" },
  { label: "7:00 PM", value: "7PM:8PM" },
  { label: "9:00 PM", value: "9PM:10PM" },
];

function getNextDays(count) {
  const days = [];
  const now = new Date();
  for (let i = 1; i <= count; i++) {
    const d = new Date(now);
    d.setDate(now.getDate() + i);
    days.push({
      date: d,
      dow: i === 1 ? "Tomorrow" : DAYS[d.getDay()],
      dom: d.getDate(),
      iso: d.toISOString().split("T")[0],
    });
  }
  return days;
}

function formatDateLabel(d) {
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  return `${d.getDate()} ${months[d.getMonth()]}`;
}

export default function ScheduleMeetingPage() {
  const [query, setQuery] = useState("");
  const [mentor, setMentor] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [holdSeconds, setHoldSeconds] = useState(587);
  const timerRef = useRef(null);

  const dates = getNextDays(6);

  useEffect(() => {
    setPageMeta(
      "Book a Mentor Session for Guidance | MentoMEET",
      "Schedule a 1-on-1 mentorship session with your IIT or AIIMS topper or Industry experts. book for just ₹249. No commitment."
    );
    if (!localStorage.getItem("token") || !localStorage.getItem("user")) {
      localStorage.setItem("lastPageUrl", "/scheduleMeeting");
      window.location.href = "/login";
      return;
    }
    timerRef.current = setInterval(() => {
      setHoldSeconds((prev) => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, []);

  const timerDisplay = `${String(Math.floor(holdSeconds / 60)).padStart(2, "0")}:${String(holdSeconds % 60).padStart(2, "0")}`;

  const selectedDateObj = dates.find((d) => d.iso === selectedDate);

  function handleSubmit() {
    if (JSON.parse(localStorage.getItem("user")) == null) {
      let redirect = window.location.href;
      localStorage.setItem("redirect", redirect);
      window.location.href = "/login";
      return;
    }

    if (!selectedDate || !query) {
      setError("Please enter your query and select a date.");
      return;
    }

    const dateObj = dates.find((d) => d.iso === selectedDate);
    if (!dateObj) {
      setError("Please select a valid date.");
      return;
    }

    let userInfo = JSON.parse(localStorage.getItem("user"));
    let menteeID = userInfo._id;
    let category = userInfo.category;
    let mobile = userInfo.mobile;
    const token = localStorage.getItem("token");
    const slot = selectedSlot || "Any Time";

    setDisabled(true);
    setError("");

    fetch(
      `https://${window.location.hostname}:5005/mentee/callback/${menteeID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          selectedDate: selectedDate,
          category,
          query,
          userInfo,
          mentor,
          slot,
          mobile,
        }),
      }
    )
      .then((res) => {
        if (res.ok) {
          setSubmitted(true);
        } else {
          if (res.status === 401) {
            setError("You do not have a valid plan. Redirecting to pricing...");
            setTimeout(() => {
              if (category === "CAREER") {
                window.location.href = "/plans";
              } else {
                window.location.href = "/pricing";
              }
            }, 2000);
          } else {
            throw new Error("Network Error");
          }
        }
      })
      .catch(() => {
        setError("Something went wrong. Please try later.");
        setDisabled(false);
      });
  }

  if (submitted) {
    return (
      <div className="bk-page">
        <style>{CSS_TEXT}</style>
        <div style={{ maxWidth: "600px", margin: "80px auto", textAlign: "center", padding: "0 24px" }}>
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>&#127881;</div>
          <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: "28px", fontWeight: 800, color: "#1E8E5A", marginBottom: "12px", textShadow: "none" }}>Session Booked!</h1>
          <p style={{ color: "#6B6480", fontSize: "15px", lineHeight: 1.6, marginBottom: "24px" }}>
            Your request has been successfully registered. You will receive an email notification within 24 hours when your request is accepted.
          </p>
          <p style={{ color: "#6B6480", fontSize: "14px", marginBottom: "32px" }}>
            Check the status of your request on your <Link to="/mentee/dashboard" style={{ color: "#5C159F", fontWeight: 600 }}>Dashboard</Link>.
          </p>
          <Link
            to="/mentee/dashboard"
            style={{
              display: "inline-block", padding: "14px 40px", background: "#5C159F", color: "#fff",
              borderRadius: "11px", fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: "15px",
              textDecoration: "none",
            }}
          >
            Go to Dashboard
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bk-page">
      <style>{CSS_TEXT}</style>

      <div className="bk-layout">
        {/* LEFT COLUMN */}
        <div>
          {/* Steps */}
          <div className="bk-steps">
            <div className="bk-step done"><span className="bk-step-num">&#10003;</span> Choose plan</div>
            <div className="bk-step-rule"></div>
            <div className="bk-step active"><span className="bk-step-num">2</span> Session details</div>
            <div className="bk-step-rule"></div>
            <div className="bk-step"><span className="bk-step-num">3</span> Confirm</div>
          </div>

          <h1 className="bk-title">Book your session</h1>
          <p className="bk-sub">Tell your mentor what to focus on, then pick a time. Your slot is held for 10 minutes while you finish.</p>

          {error && <div className="bk-msg bk-msg-err">{error}</div>}

          {/* Mentor */}
          <div className="bk-section">
            <p className="bk-section-label">Preferred Mentor</p>
            <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
              <div className="bk-avatar">M</div>
              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  value={mentor}
                  onChange={(e) => setMentor(e.target.value)}
                  placeholder="Enter mentor name (optional)"
                  style={{
                    width: "100%", border: "1.5px solid #E4D9F5", borderRadius: "9px",
                    padding: "10px 14px", fontFamily: "'Inter',sans-serif", fontSize: "13.5px",
                    color: "#1A1330", outline: "none",
                  }}
                />
              </div>
              <Link to="/mentors" className="bk-change-link">Browse mentors</Link>
            </div>
          </div>

          {/* Query */}
          <div className="bk-section">
            <p className="bk-section-label">What do you need help with?</p>
            <textarea
              className="bk-textarea"
              maxLength={300}
              placeholder="e.g. I keep losing marks on rotational mechanics problems in mock tests. Can we go through my approach?"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <p className="bk-char-count">{query.length}/300 &mdash; this goes straight to your mentor before the call</p>
          </div>

          {/* Date & Time */}
          <div className="bk-section">
            <p className="bk-section-label">Pick a date &amp; time</p>
            <div className="bk-date-row">
              {dates.map((d) => (
                <div
                  key={d.iso}
                  className={`bk-date-pill${selectedDate === d.iso ? " selected" : ""}`}
                  onClick={() => setSelectedDate(d.iso)}
                >
                  <div className="bk-dow">{d.dow}</div>
                  <div className="bk-dom">{d.dom}</div>
                </div>
              ))}
            </div>
            <div className="bk-slot-grid">
              {SLOTS.map((s) => (
                <div
                  key={s.value}
                  className={`bk-slot${selectedSlot === s.value ? " selected" : ""}`}
                  onClick={() => setSelectedSlot(s.value)}
                >
                  {s.label}
                </div>
              ))}
            </div>
            <div className="bk-hold-banner">
              <span className="bk-hold-dot"></span> Slot held for <span style={{ marginLeft: "4px", marginRight: "4px" }}>{timerDisplay}</span> &mdash; finish booking before it's released
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN — TICKET */}
        <div className="bk-ticket-wrap">
          <div className="bk-ticket">
            <div className="bk-ticket-top">
              <p className="bk-ticket-eyebrow">Booking Summary</p>
              <p className="bk-ticket-title">Session{mentor ? ` with ${mentor}` : " with MentoMEET"}</p>
              <div className="bk-ticket-timer">&#9201; Slot held &mdash; {timerDisplay}</div>
            </div>

            <div className="bk-ticket-row">
              <span className="bk-label">Date</span>
              <span className={`bk-value${!selectedDateObj ? " muted" : ""}`}>
                {selectedDateObj ? formatDateLabel(selectedDateObj.date) : "Not selected"}
              </span>
            </div>
            <div className="bk-ticket-row">
              <span className="bk-label">Time</span>
              <span className={`bk-value${!selectedSlot ? " muted" : ""}`}>
                {selectedSlot ? (SLOTS.find((s) => s.value === selectedSlot) || {}).label || selectedSlot : "Not selected"}
              </span>
            </div>
            <div className="bk-ticket-row">
              <span className="bk-label">Duration</span>
              <span className="bk-value muted">45 minutes</span>
            </div>
            <div className="bk-ticket-row">
              <span className="bk-label">Query</span>
              <span className="bk-value muted">
                {query.trim() ? (query.length > 40 ? query.slice(0, 40) + "\u2026" : query) : "Not added yet"}
              </span>
            </div>

            <div style={{ padding: "0 24px" }}><div className="bk-perforation"></div></div>

            <div className="bk-ticket-bottom">
              <button
                className="bk-cta-btn"
                disabled={isDisabled}
                onClick={handleSubmit}
              >
                {isDisabled ? "Submitting..." : "Confirm Session"}
              </button>
              <p className="bk-cta-sub">Your request will be reviewed &mdash; you'll get an email within 24 hours</p>
              <Link to="/pricing" className="bk-compare-link">See full plan comparison &rarr;</Link>
            </div>
          </div>

          <div className="bk-trust-strip">
            <div className="bk-trust-row"><span className="bk-trust-icon">&#10003;</span> <span>Free reschedule up to 2 hrs before</span></div>
            <div className="bk-trust-row"><span className="bk-trust-icon">&#10003;</span> <span>Full refund if mentor doesn't show</span></div>
            <div className="bk-trust-row"><span className="bk-trust-icon">&#10003;</span> <span>Secure payments via Razorpay</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}